/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-legal-entity-card-view',
  templateUrl: './legal-entity-card-view.component.html',
  styleUrls: ['./legal-entity-card-view.component.scss']
})
export class LegalEntityCardViewComponent {

  @Input() legalEntity: LegalEntityModel | undefined = undefined;

}
